import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { chatKitSessionBody, AI_ASSISTANT_API_BASE_URL } from '../constants'

export const useChatKitActions = () => {
  const { fetcher: clientSecretFetcher } = useFetch<
    RequestMethodsEnum.post,
    { clientSecret: string }
  >({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: escalateFetcher } = useFetch<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })

  const getClientSecret = async () =>
    clientSecretFetcher(`${AI_ASSISTANT_API_BASE_URL}/chatkit/session`, chatKitSessionBody)

  const escalateSupportRequest = async (params: Record<string, unknown>) =>
    escalateFetcher(`${AI_ASSISTANT_API_BASE_URL}/support/escalate`, params)

  return {
    getClientSecret,
    escalateSupportRequest,
  }
}
